<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Přidat novou fakturu za dopravu</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <datepicker label="Datum" class="mx-2" v-model="datum" clearable></datepicker>
                </v-flex>
                <v-flex xs12 sm6>
                  <dodavatele></dodavatele>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1">
                    <v-data-table
                      :headers="headersDetail"
                      :items="itemsDetail"
                      :pagination.sync="pagination"
                      :total-items="pagination.totalItems"
                      :rows-per-page-items="[25, 50, 100, 200]"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.datum_faktury_zbozi }}</td>
                        <td>{{ props.item.cislo_faktury_zbozi }}</td>
                        <td width="200">
                          <v-text-field
                            suffix="EUR"
                            type="number"
                          ></v-text-field>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Detail faktury za dopravu</h2>
          </v-card-title>
          <div v-if="!editMode">
            <v-card-text class="pt-0 pb-2">
              <v-form ref="createForm">
                <v-layout row wrap>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Datum:</p> <strong>23. 4. 2019</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Dodavatel:</p> <strong>Jan Smrťák</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Číslo faktury:</p> <strong>7776665551</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Dopravné celkem:</p> <strong>200 Kč</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <div class="table-border__radius elevation-1">
                      <v-data-table
                        :headers="headersDetail"
                        :items="itemsDetail"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.datum_faktury_zbozi }}</td>
                          <td>{{ props.item.cislo_faktury_zbozi }}</td>
                          <td>{{ props.item.doprava_eur }}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-3 elevation-0" dark @click="editMode=true">Upravit</v-btn>
              <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
            </v-card-actions>
          </div>
          <div v-else>
            <v-card-text class="pt-0 pb-2">
              <v-form ref="createForm">
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <datepicker label="Datum" class="mx-2" clearable></datepicker>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <dodavatele></dodavatele>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <div class="table-border__radius elevation-1">
                      <v-data-table
                        :headers="headersDetail"
                        :items="itemsDetail"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.datum_faktury_zbozi }}</td>
                          <td>{{ props.item.cislo_faktury_zbozi }}</td>
                          <td width="200">
                            <v-text-field
                              suffix="EUR"
                              type="number"
                            ></v-text-field>
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Uložit</v-btn>
              <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm9>
                <h3>Faktury za dopravné</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3>
                <v-btn color="blue darken-3" class="ma-0 mb-3 right" outline @click="dialogCreate=true">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat fakturu
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum }}</td>
                  <td>{{ props.item.dodavatel }}</td>
                  <td>{{ props.item.cislo_faktury }}</td>
                  <td>{{ props.item.dopravne }}</td>
                  <td class="text-center">
                    <v-btn @click="detailClick(props.item)" color="primary" class="elevation-0 ma-0 mr-2">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                    <v-btn flat icon class="elevation-0 ma-0">
                      <v-icon flat color="red">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Dodavatel', value: 'dodavatel' },
        { text: 'Č. faktury', value: 'cislo_faktury' },
        { text: 'Dopravné celkem', value: 'dopravne', sortable: false },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      headersDetail: [
        { text: 'Datum faktury za zboží', value: 'datum_faktury_zbozi', sortable: false },
        { text: 'Číslo faktury za zboží', value: 'cislo_faktury_zbozi', sortable: false },
        { text: 'Eur za dopravné', value: 'doprava_eur', sortable: false }
      ],
      items: [
        {
          datum: '22. 3. 2019',
          dodavatel: 'Jan Novák',
          cislo_faktury: '7776665551',
          dopravne: '150 Kč'
        },
        {
          datum: '22. 3. 2019',
          dodavatel: 'Jan Novák',
          cislo_faktury: '7776665552',
          dopravne: '150 Kč'
        }
      ],
      itemsDetail: [
        {
          datum_faktury_zbozi: '22. 3. 2019',
          cislo_faktury_zbozi: '7776665551',
          doprava_eur: '200 Kč'
        }
      ],
      dialogCreate: false,
      dialogDetail: false,
      //items: [],
      removeItem: {},
      removing: false,
      dialogCreate: false,
      dialogDetail: false,
      dialogInit: { datul: null, dodavatel: null, cislo_faktury: null, dopravne: null},
      newItem: null,
      updating: false,
      sending: false,
      detailItem: null,
      editItem: null,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
    }
  },
  mounted: function() {
    //window.MenuListener.show();
    //this.load();
  },
  props: {

  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("dodavatele/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items = body.data;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("dodavatele", this.newItem).then(function(body) {
          if (body.inserted) {
            this.load();
            this.dialogCreate = false;
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    detailClick (e) {
      this.detailItem = window.th.copy(e);
      this.dialogDetail = true;
    },
    editClick () {
      this.editItem = window.th.copy(this.detailItem);
      this.editMode = true;
    },
    edit () {
      this.sending = true;
      window.API.put("dodavatele/" + this.detailItem.id, this.editItem).then(function(body) {
        if (body.updated) {
          this.load();
          this.editMode = false;
          this.dialogDetail = false;
        }
        this.sending = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    },
    remove () {
      this.removing = true;
      window.api.delete("dodavatele/" + this.detailItem.id).then((_body) => {
        if (_body.deleted) {
          this.dialogDetail = false;
          this.load();
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Faktury/Faktury.vue